import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EnvironmentTwoToneSvg from "@ant-design/icons-svg/es/asn/EnvironmentTwoTone";
import AntdIcon from "../components/AntdIcon";
var EnvironmentTwoTone = function EnvironmentTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EnvironmentTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EnvironmentTwoTone.displayName = 'EnvironmentTwoTone';
}
export default /*#__PURE__*/React.forwardRef(EnvironmentTwoTone);